import { __rest } from "tslib";
import React from 'react';
import cn from 'classnames';
import Button from "../CTA/Button";
import styles from './IconLinksListWithDivider.module.scss';
const IconLinksListWithDivider = ({ iconLinkList = [], className, divider = 'show', }) => {
    return (React.createElement("ul", { className: styles.iconLinkList }, iconLinkList.map((_a) => {
        var { Tag, href, to, label, icon, iconWithText } = _a, props = __rest(_a, ["Tag", "href", "to", "label", "icon", "iconWithText"]);
        return (React.createElement("li", { key: label, className: cn(styles.linkListCard, className, divider === 'hide' && styles.hideDivider) },
            React.createElement(Button, Object.assign({ primary: false, Tag: Tag, iconElement: icon, iconPosition: "top" }, (Tag === 'a' ? { href } : { to }), props), iconWithText || label)));
    })));
};
export default IconLinksListWithDivider;
//# sourceMappingURL=IconLinksListWithDivider.js.map